'use client';

import React from 'react';
import { Flame, Package } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useCommerce } from '@/context/CommerceContext';
import ProductCard from '@/components/ProductCard';

export default function ShopPage() {
  const { products, setIsRfqOpen } = useCommerce();

  return (
    <main className="min-h-screen flex flex-col bg-white">
      <Header />

      {/* 1. Shop Header */}
      <section className="bg-[#FAFBF9] border-b border-neutral-200 py-10 sm:py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-3">
          <div className="inline-flex items-center space-x-1.5 text-xs font-bold uppercase tracking-wider text-emerald-800 bg-emerald-100/70 px-3 py-1 rounded-full">
            <Flame className="w-3.5 h-3.5 text-amber-600" />
            <span>Wood-Fired & Cold-Pressed Kadai Frying</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-neutral-900 uppercase tracking-tight">
            ARTISANAL CHIPS & SAVOURIES CATALOGUE
          </h1>
          <p className="text-sm sm:text-base text-neutral-600 max-w-2xl mx-auto font-medium">
            Every batch is slow-roasted upon order in 100% pure cold-pressed groundnut & coconut oil.
            Zero palm oil, zero chemical preservatives, sealed in crunch-lock freshness packs.
          </p>
        </div>
      </section>

      {/* 2. Product Grid */}
      <section className="py-12 bg-white flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {products.length === 0 ? (
            <div className="py-20 text-center max-w-md mx-auto space-y-4">
              <div className="w-14 h-14 rounded-full bg-emerald-50 text-emerald-700 flex items-center justify-center mx-auto">
                <Package className="w-7 h-7" />
              </div>
              <h3 className="text-lg font-bold text-neutral-800">No Products in Catalog</h3>
              <p className="text-xs sm:text-sm text-neutral-500">
                Our kitchen is frying fresh traditional batches. Please check back shortly or create a custom gift box.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
              {products.map((product, idx) => (
                <ProductCard key={product.id} product={product} index={idx} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* 3. Promotional Interstitial Banner */}
      <section className="bg-[#0A261A] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 bg-white/5 border border-white/10 rounded-3xl p-6 sm:p-10 backdrop-blur-xs">
            <div className="space-y-2 max-w-xl text-center md:text-left">
              <span className="text-xs font-bold uppercase tracking-wider text-[#F5B52E]">
                CATERING & WEDDING FAVORS
              </span>
              <h3 className="text-2xl sm:text-3xl font-semibold uppercase tracking-tight">
                Planning a Family Gathering or Event?
              </h3>
              <p className="text-xs sm:text-sm text-neutral-300 font-medium leading-relaxed">
                Order 5kg or more of any savoury for wholesale pricing with vacuum airtight packaging, custom labels, and direct delivery.
              </p>
            </div>

            <div className="flex items-center space-x-3 shrink-0">
              <button
                onClick={() => setIsRfqOpen(true)}
                className="px-6 py-3 rounded-full bg-[#F5B52E] hover:bg-[#ffc34d] text-[#0A261A] font-bold text-xs sm:text-sm uppercase tracking-wider shadow-md transition-all cursor-pointer"
              >
                Request Bulk Quotation
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
